module.exports = __webpack_public_path__ + "static/media/vivek.6080e671.jpg";